import { getLocationsData } from '../localization/localization'
import { static_url } from '../config'

import { renderMarkup } from '../servicesCommonFns'

async function renderRomainImg() {
  const clientLocationData = await getLocationsData()
  const htmlFragment = document.createDocumentFragment()
  const romainsBlock = document.querySelector('[data-romania-consumers]')

  if (clientLocationData?.clients_country_id === '181') {
    const itemElement = document.createElement('div')
    itemElement.classList.add('footer__romania-wrapper')
    itemElement.innerHTML = `
    <a href="https://anpc.ro/ce-este-sal/" target="_blank">
      <img
      class="footer__romania-logo"
      width="115"
      height="30"
      alt="ANPC"
      src="${static_url}/site/images/anpc_sal.webp" 
      />
    </a>

    <a href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=RO" target="_blank">
      <img
      class="footer__romania-logo"
      width="115"
      height="30"
      alt="EU sol logo"
      src="${static_url}/site/images/eu_sol.webp" 
      />
    </a>`

    htmlFragment.appendChild(itemElement)

    renderMarkup(romainsBlock, htmlFragment)
  } else {
    if (romainsBlock) romainsBlock.remove()
  }
}

renderRomainImg()
